import React from 'react';
import { generateDestinationMapLink } from '../../sections/sitewide/components/locationMap/helpers/googleMapApi';
import { ClickableTextTypes } from './ClickableTextTypes';

export const ClickableText = ({
  text,
  type,
  url,
  addressDetails,
  className = '',
  onCustom,
}: ClickableTextTypes.IClickableText) => {
  const handleAddress = () => {
    if (addressDetails) {
      const { gMapDetails, googleMapPlaceId } = addressDetails;
      const destination = {
        coords: {
          lat: gMapDetails.geometry.location.lat,
          lng: gMapDetails.geometry.location.lng,
        },
        placeId: googleMapPlaceId,
      };
      return generateDestinationMapLink(destination);
    }
    return '';
  };

  const getLink = () => {
    switch (type) {
      case 'phone':
        return `tel:${text.split('-').join('')}`;
      case 'email':
        return `mailto:${text}`;
      case 'address':
        return handleAddress() || url;
      case 'link':
        return text;
      default:
        return '';
    }
  };

  const targetType = {
    phone: '_self',
    email: '_self',
    address: '_blank',
    link: '_blank',
    custom: undefined,
  };

  return (
    <a
      className={`${className}`}
      href={getLink()}
      onClick={type === 'custom' ? onCustom : undefined}
      target={targetType[type]}
      rel="nofollow"
    >
      {text}
    </a>
  );
};
